<template>
  <div>
    <div class="text-subtitle1">Average Weather (Historical)</div>
    <q-table
      dense
      :rows-per-page-options="[0]"
      class="weather-summary"
      :data="normals"
      :columns="weatherColumns"
      :loading="loading"
      flat
      row-key="name"
      :hide-pagination="true"
      no-data-label="Weather data unavailable."
    ></q-table>
    <div
      v-if="normals.length"
      class="weather-summary-caption q-my-sm text-caption text-italic text-grey-8"
    >
      Based on the most recent National Oceanic and Atmospheric Administration
      (NOAA) Climate Normals. Normals are calculated for a uniform 30 year
      period from almost 15,000 weather stations across the U.S.
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getNormalsByZip } from "@/apis/weather-service";

export default {
  name: "WeatherSummary",
  props: {
    zip: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      normals: [],
      loading: false,
      shortMonths: Array.from({ length: 12 }, (x, index) =>
        new Date(0, index)
          .toLocaleDateString("en-US", { month: "short" })
          .toLowerCase(),
      ),
      longMonths: Array.from({ length: 12 }, (x, index) =>
        new Date(0, index).toLocaleDateString("en-US", { month: "long" }),
      ),
      weatherColumns: [
        {
          name: "month",
          required: true,
          label: "Month",
          align: "left",
          field: row => row.monthLabel,
        },
        {
          name: "tempMax",
          label: "Hi °F",
          field: "tempMax",
          format: val => `${Math.round(val)}°`,
          sortable: true,
          sort: (a, b) => parseFloat(a) - parseFloat(b),
        },
        //tempAvg not included in mockup: { name: "tempAvg", label: "Avg", field: "tempAvg", format: val => `${val}°`, sortable: true },
        {
          name: "tempMin",
          label: "Low °F",
          field: "tempMin",
          format: val => `${Math.round(val)}°`,
          sortable: true,
          sort: (a, b) => parseFloat(a) - parseFloat(b),
        },
        {
          name: "precipAvg",
          label: "Precip (in)",
          field: "precipAvg",
          format: val => `${parseFloat(val).toFixed(2)}"`,
          sortable: true,
          sort: (a, b) => parseFloat(a) - parseFloat(b),
        },
      ],
    };
  },
  computed: {
    ...mapState(["idToken"]),
  },
  mounted() {},
  watch: {
    idToken: {
      handler(newVal) {
        if (!newVal) {
          return;
        }

        const token = this.idToken;
        const zip = this.zip;

        return this.fetchNormalsByZip(token, zip);
      },
      immediate: true,
    },
  },
  methods: {
    weatherTableDataFormat(weatherObjects, objType, month) {
      return weatherObjects[objType][month];
    },
    fetchNormalsByZip(token, zip) {
      this.loading = true;

      return getNormalsByZip(token, zip)
        .then(response => {
          const shortMonths = this.shortMonths;
          const longMonths = this.longMonths;

          this.normals = shortMonths.map(month => {
            var newWeatherObject = {
              month: month,
              monthLabel: longMonths[shortMonths.indexOf(month)],
              tempMax: this.weatherTableDataFormat(response, "tempMax", month),
              tempMin: this.weatherTableDataFormat(response, "tempMin", month),
              tempAvg: this.weatherTableDataFormat(response, "tempAvg", month),
              precipAvg: this.weatherTableDataFormat(
                response,
                "precipAvg",
                month,
              ),
            };

            return newWeatherObject;
          });
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.weather-summary table {
  width: min-content;
}

.weather-summary table.q-table th {
  font-weight: bold;
}

.weather-summary-caption {
  max-width: 350px;
}
</style>
